<template>
  <vx-tooltip :text="$t('dial')" position="bottom">
    <vs-button radius color="primary" type="border" icon="dialpad" size="small" @click.prevent="call"></vs-button>
  </vx-tooltip>
</template>

<script>
import Cti from '@/models/Cti'

export default {
  name: 'ClickToCall',
  props: {
    phoneNumber: {
      required: true
    }
  },
  computed: {
    callData () {
      return {
        channel: this.phoneNumber,
        extension: this.$store.getters.extension,
        context: this.$store.getters.userInfo.context
      }
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    server () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {}
    }
  },
  methods: {
    call () {
      if (!this.isLoggedIn) {
        this.$swalHelper.error({
          title: this.$t('error'),
          text: this.$t('cti_not_logged_in'),
          confirmButton: this.$t('confirm')
        })
        return
      }
      try {
        Cti.dial(this.server.domain, this.callData)
        this.$alertHelper.success(`${this.phoneNumber} 으로 발신완료`)
      } catch (e) {
        this.$alertHelper.error('Dial Error')
      }
    }
  }
}
</script>

<style scoped>

</style>
